<template>
 <div class="pb100 fs28">
   <volunteerdata/>
   <crumbs detail="true"/>
   <div class="container">
     <div class="mt20 mb20">
       <div class="model2box bgfff">
         <div class="imgbox">
           <img class="imgtop" :src="detail.image" alt="">
         </div>
         <div class="txtbox">
           <ul>
             <li>姓名：<span>{{ detail.name }}</span></li>
             <li>性别：<span>{{ detail.sex === 1 ? '男' : '女' }}</span></li>
             <li>参与社团：<span>{{ detail.name }}</span></li>
             <li>服务时长：<span>{{ detail.serviceTime }}</span></li>
             <li>服务类别：<span>{{ detail.serviceType }}</span></li>
             <li>简介：<span>{{ detail.introduction }}</span></li>
           </ul>
         </div>
       </div>
       <div class="pubtitle">
         <h2>参与的活动<span>/ Participation Activities</span></h2>
       </div>
       <ul class="ul-model1 clearfix">
         <li v-for="(item, index) in List2" :key="index">
           <router-link :to="'/volunteeractivitydetail?columnId=' + item.menuId + '&id=' + item.id">
             <div class="imgbox">
               <img class="imgtop" :src="getImage(item.image)" alt="">
             </div>
             <div class="txtbox">
               <h2 class="textover">{{ item.name }}</h2>
               <div class="descbox">
                 <p class="textover">日期：<span>{{ item.activityDate }}</span></p>
                 <p class="textover">地点：<span>{{ item.address }}</span></p>
               </div>
             </div>
           </router-link>
         </li>
       </ul>
       <nodata v-show="nodataflag2"/>
       <el-pagination
         v-if="listTotal2 > Param2.limit "
         @current-change="handleCurrentChange2"
         :page-size="Param2.limit"
         :pager-count="5"
         :current-page.sync="currentPage1"
         layout="prev, pager, next"
         :total="listTotal2"
         class="pagemodel1">
       </el-pagination>
       <div class="pubtitle">
         <h2>加入的社团<span>/ Join Team</span></h2>
       </div>
       <ul class="ul-model1 clearfix">
         <li v-for="(item, index) in List1" :key="index">
           <router-link :to="'/volunteercommunitydetail?columnId=' + item.menuId + '&id=' + item.id">
             <div class="imgbox">
               <img class="imgtop" :src="getImage(item.image)" alt="">
             </div>
             <div class="txtbox">
               <h2 class="textover">{{ item.name }}</h2>
               <div class="descbox">
                 <p class="textover">活动次数：<span>{{ item.activityNum }}</span></p>
                 <p class="textover">服务类别：<span>{{ item.name }}</span></p>
               </div>
             </div>
           </router-link>
         </li>
       </ul>
       <nodata v-show="nodataflag1"/>
       <el-pagination
         v-if="listTotal1 > Param1.limit "
         @current-change="handleCurrentChange1"
         :page-size="Param1.limit"
         :pager-count="5"
         :current-page.sync="currentPage1"
         layout="prev, pager, next"
         :total="listTotal1"
         class="pagemodel1">
       </el-pagination>
     </div>
   </div>
 </div>
</template>

<script>
import volunteerdata from '@/view/volunteercenter/volunteerdata'
import crumbs from '@/components/crumbs/index'
import {
  Volunteerdetail,
  VolunteergroupList,
  VolunteeractivityList
} from '@/api/volunteer/index'
import Comment from '@/components/comment/index'
import RightSidebar from '@/components/rightsidebar/index'
import goTop from '@/components/gotop/index'
import pv from '@/components/amount/pv'
import nodata from '@/components/nodata/index'
export default {
  name: 'volunteerdetail',
  meta: {
    showHeader: true
  },
  components: {
    Comment,
    RightSidebar,
    goTop,
    pv,
    crumbs,
    volunteerdata,
    nodata
  },
  data () {
    return {
      detail: '',
      isCommentshow: true, // 是否显示评论
      pv: 0,
      commentTotal: '',
      commentOffsettop: '',
      Param1: {
        pageNum: 1,
        limit: 4
      },
      nodataflag1: false,
      currentPage1: 1,
      List1: [],
      listTotal1: 0,
      Param2: {
        pageNum: 1,
        limit: 12
      },
      List2: [],
      listTotal2: 0,
      nodataflag2: false,
      currentPage2: 1
    }
  },
  mounted () {
    this.getDetail()
    this.getList1()
    this.getList2()
  },
  methods: {
    getImage (val) {
      if (val === undefined) {
        return require('@/assets/common/images/default.png')
      } else {
        return val
      }
    },
    // 分页触发
    handleCurrentChange1 (val) {
      this.Param1.pageNum = val
      this.getList1()
    },
    // 分页触发
    handleCurrentChange2 (val) {
      this.Param2.pageNum = val
      this.getList2()
    },
    getList1 () {
      VolunteergroupList(parseInt(this.$route.query.id), this.Param1).then(res => {
        if (res.data.status === 0) {
          this.listTotal = res.data.totalSize
          if (this.listTotal === 0) {
            this.nodataflag1 = true
          } else {
            this.nodataflag1 = false
          }
          this.List1 = res.data.data
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    getList2 () {
      VolunteeractivityList(parseInt(this.$route.query.id), this.Param2).then(res => {
        if (res.data.status === 0) {
          this.listTotal2 = res.data.totalSize
          if (this.listTotal2 === 0) {
            this.nodataflag2 = true
          } else {
            this.nodataflag2 = false
          }
          this.List2 = res.data.data
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    /* 获取信息详情 */
    getDetail () {
      Volunteerdetail(this.$route.query.id).then((res) => {
        console.log(res)
        if (res.data.status === 200) {
          this.detail = res.data.data
        } else {
          this.$message.error(res.data.message)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.pubtitle{
  height: 50px;
  border-bottom: solid 1px #eaedf1;
  margin: 20px 0;
  position: relative;
  h2 {
    float: left;
    padding: 0 0 0 34px;
    background: url('~@/assets/common/icon/icon-volunteer.png') left top no-repeat;
    span {
      color: rgb(204, 204, 204);
      margin-left: 10px;
      font-size: 16px;
    }
  }
  &:after {
    position: absolute;
    display: block;
    height: 1px;
    background: #fff;
    width: 100%;
    content: '';
    left: 0;
    bottom: -2px;
  }
}
.ul-model1 li a .txtbox .descbox {
  height: 54px;
}
</style>



// WEBPACK FOOTER //
// src/view/volunteercenter/volunteerdetail.vue